(function() {
  function initSupportHome(section) {
    if (!section || section.dataset.supportHomeReady === 'true') {
      return;
    }

    section.dataset.supportHomeReady = 'true';

    var productShell = section.querySelector('[data-support-home-products]');

    if (!productShell) {
      return;
    }

    var groupButtons = Array.prototype.slice.call(productShell.querySelectorAll('[data-support-home-group]'));
    var subcategoryLists = Array.prototype.slice.call(productShell.querySelectorAll('[data-support-home-subcategories]'));
    var subcategoryButtons = Array.prototype.slice.call(productShell.querySelectorAll('[data-support-home-subcategory]'));
    var cards = Array.prototype.slice.call(productShell.querySelectorAll('[data-support-home-card]'));
    var emptyState = productShell.querySelector('[data-support-home-empty]');
    var productGrid = productShell.querySelector('[data-support-home-grid]');
    var mobileAccordionsHost = productShell.querySelector('[data-support-home-mobile-accordions]');
    var activeGroupKey = '';
    var activeSubcategoryKey = '';
    var mobileOpenSubcategoryKey = '';

    if (!groupButtons.length || !subcategoryButtons.length || !cards.length) {
      return;
    }

    function findFirstSubcategory(groupKey) {
      var list = productShell.querySelector('[data-support-home-subcategories][data-group-key="' + groupKey + '"]');

      if (!list) {
        return '';
      }

      var button = list.querySelector('[data-support-home-subcategory]');
      return button ? button.getAttribute('data-subcategory-key') || '' : '';
    }

    function buildMobileAccordions() {
      if (!mobileAccordionsHost) {
        return;
      }

      mobileAccordionsHost.innerHTML = '';

      groupButtons.forEach(function(groupButton) {
        var groupKey = groupButton.getAttribute('data-group-key') || '';
        var groupWrapper = document.createElement('div');
        var groupSubcategories = subcategoryButtons.filter(function(button) {
          return button.getAttribute('data-group-key') === groupKey;
        });

        groupWrapper.className = 'support-home__product-mobile-group';
        groupWrapper.setAttribute('data-support-home-mobile-group', '');
        groupWrapper.setAttribute('data-group-key', groupKey);

        groupSubcategories.forEach(function(subcategoryButton) {
          var subcategoryKey = subcategoryButton.getAttribute('data-subcategory-key') || '';
          var accordion = document.createElement('div');
          var toggle = document.createElement('button');
          var label = document.createElement('span');
          var icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          var iconPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          var panel = document.createElement('div');
          var grid = document.createElement('div');
          var matches = cards.filter(function(card) {
            return (
              card.getAttribute('data-group-key') === groupKey &&
              card.getAttribute('data-subcategory-key') === subcategoryKey
            );
          });

          accordion.className = 'support-home__product-mobile-accordion';
          toggle.className = 'support-home__product-mobile-accordion-button';
          toggle.type = 'button';
          toggle.setAttribute('aria-expanded', 'false');
          toggle.setAttribute('data-support-home-mobile-accordion', '');
          toggle.setAttribute('data-group-key', groupKey);
          toggle.setAttribute('data-subcategory-key', subcategoryKey);

          label.textContent = subcategoryButton.textContent.trim();

          icon.setAttribute('viewBox', '0 0 20 20');
          icon.setAttribute('fill', 'none');
          icon.setAttribute('aria-hidden', 'true');
          iconPath.setAttribute('d', 'M5.5 7.5L10 12L14.5 7.5');
          iconPath.setAttribute('stroke', 'currentColor');
          iconPath.setAttribute('stroke-width', '1.8');
          iconPath.setAttribute('stroke-linecap', 'round');
          iconPath.setAttribute('stroke-linejoin', 'round');
          icon.appendChild(iconPath);

          toggle.appendChild(label);
          toggle.appendChild(icon);

          panel.className = 'support-home__product-mobile-accordion-panel';
          panel.setAttribute('data-support-home-mobile-panel', '');
          panel.setAttribute('data-group-key', groupKey);
          panel.setAttribute('data-subcategory-key', subcategoryKey);
          panel.hidden = true;

          grid.className = 'support-home__product-grid support-home__product-grid--mobile';

          matches.forEach(function(card) {
            var clone = card.cloneNode(true);
            clone.hidden = false;
            grid.appendChild(clone);
          });

          panel.appendChild(grid);
          accordion.appendChild(toggle);
          accordion.appendChild(panel);
          groupWrapper.appendChild(accordion);
        });

        mobileAccordionsHost.appendChild(groupWrapper);
      });

      mobileAccordionsHost.hidden = false;
    }

    function syncCards() {
      var visibleCount = 0;

      cards.forEach(function(card) {
        var matches =
          card.getAttribute('data-group-key') === activeGroupKey &&
          card.getAttribute('data-subcategory-key') === activeSubcategoryKey;

        card.hidden = !matches;

        if (matches) {
          visibleCount += 1;
        }
      });

      if (emptyState) {
        emptyState.classList.toggle('is-visible', visibleCount === 0);
      }

      if (productGrid) {
        productGrid.classList.toggle('is-empty', visibleCount === 0);
      }
    }

    function syncDesktopNav() {
      subcategoryLists.forEach(function(list) {
        var matches = list.getAttribute('data-group-key') === activeGroupKey;
        list.classList.toggle('is-active', matches);
        list.hidden = !matches;
      });

      subcategoryButtons.forEach(function(button) {
        var matches =
          button.getAttribute('data-group-key') === activeGroupKey &&
          button.getAttribute('data-subcategory-key') === activeSubcategoryKey;

        button.classList.toggle('is-active', matches);
        button.setAttribute('aria-pressed', matches ? 'true' : 'false');
      });
    }

    function syncMobileAccordions() {
      if (!mobileAccordionsHost) {
        return;
      }

      var mobileGroups = Array.prototype.slice.call(
        mobileAccordionsHost.querySelectorAll('[data-support-home-mobile-group]')
      );
      var accordionButtons = Array.prototype.slice.call(
        mobileAccordionsHost.querySelectorAll('[data-support-home-mobile-accordion]')
      );
      var accordionPanels = Array.prototype.slice.call(
        mobileAccordionsHost.querySelectorAll('[data-support-home-mobile-panel]')
      );

      mobileGroups.forEach(function(group) {
        var matches = group.getAttribute('data-group-key') === activeGroupKey;
        group.classList.toggle('is-active', matches);
        group.hidden = !matches;
      });

      accordionButtons.forEach(function(button) {
        var matches =
          button.getAttribute('data-group-key') === activeGroupKey &&
          button.getAttribute('data-subcategory-key') === mobileOpenSubcategoryKey;

        button.classList.toggle('is-active', matches);
        button.setAttribute('aria-expanded', matches ? 'true' : 'false');
      });

      accordionPanels.forEach(function(panel) {
        var matches =
          panel.getAttribute('data-group-key') === activeGroupKey &&
          panel.getAttribute('data-subcategory-key') === mobileOpenSubcategoryKey;

        panel.hidden = !matches;
      });
    }

    function setSubcategory(groupKey, subcategoryKey) {
      activeGroupKey = groupKey;
      activeSubcategoryKey = subcategoryKey;
      mobileOpenSubcategoryKey = subcategoryKey;

      syncDesktopNav();
      syncCards();
      syncMobileAccordions();
    }

    function setGroup(groupKey) {
      activeGroupKey = groupKey;

      groupButtons.forEach(function(button) {
        var matches = button.getAttribute('data-group-key') === groupKey;
        button.classList.toggle('is-active', matches);
        button.setAttribute('aria-selected', matches ? 'true' : 'false');
      });

      var currentActive = productShell.querySelector(
        '[data-support-home-subcategory].is-active[data-group-key="' + groupKey + '"]'
      );
      var nextSubcategoryKey = currentActive
        ? currentActive.getAttribute('data-subcategory-key') || ''
        : findFirstSubcategory(groupKey);

      if (!nextSubcategoryKey) {
        nextSubcategoryKey = findFirstSubcategory(groupKey);
      }

      if (nextSubcategoryKey) {
        setSubcategory(groupKey, nextSubcategoryKey);
      }
    }

    function getCardUrl(card) {
      return card ? card.getAttribute('data-support-home-card-url') || '' : '';
    }

    function navigateFromCard(card) {
      var targetUrl = getCardUrl(card);

      if (!targetUrl) {
        return;
      }

      window.location.assign(targetUrl);
    }

    buildMobileAccordions();

    groupButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        var groupKey = button.getAttribute('data-group-key');

        if (!groupKey || groupKey === activeGroupKey) {
          return;
        }

        setGroup(groupKey);
      });
    });

    subcategoryButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        var groupKey = button.getAttribute('data-group-key');
        var subcategoryKey = button.getAttribute('data-subcategory-key');

        if (!groupKey || !subcategoryKey) {
          return;
        }

        setSubcategory(groupKey, subcategoryKey);
      });
    });

    if (mobileAccordionsHost) {
      mobileAccordionsHost.addEventListener('click', function(event) {
        var toggle = event.target.closest('[data-support-home-mobile-accordion]');

        if (!toggle) {
          return;
        }

        var groupKey = toggle.getAttribute('data-group-key');
        var subcategoryKey = toggle.getAttribute('data-subcategory-key');

        if (!groupKey || !subcategoryKey) {
          return;
        }

        if (groupKey === activeGroupKey && subcategoryKey === mobileOpenSubcategoryKey) {
          mobileOpenSubcategoryKey = '';
          syncMobileAccordions();
          return;
        }

        setSubcategory(groupKey, subcategoryKey);
      });
    }

    productShell.addEventListener('click', function(event) {
      var card = event.target.closest('[data-support-home-card]');

      if (!card || !productShell.contains(card)) {
        return;
      }

      if (event.target.closest('a, button, input, select, textarea, summary, label')) {
        return;
      }

      navigateFromCard(card);
    });

    productShell.addEventListener('keydown', function(event) {
      var card = event.target.closest('[data-support-home-card]');

      if (!card || !productShell.contains(card)) {
        return;
      }

      if (event.target.closest('a, button, input, select, textarea, summary, label')) {
        return;
      }

      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }

      event.preventDefault();
      navigateFromCard(card);
    });

    var initialGroup = productShell.querySelector('[data-support-home-group].is-active') || groupButtons[0];

    if (initialGroup) {
      setGroup(initialGroup.getAttribute('data-group-key') || '');
    }
  }

  function initAllSupportHomes(root) {
    var scope = root && root.querySelectorAll ? root : document;

    if (scope.matches && scope.matches('[data-support-home]')) {
      initSupportHome(scope);
    }

    Array.prototype.slice.call(scope.querySelectorAll('[data-support-home]')).forEach(function(section) {
      initSupportHome(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAllSupportHomes(document);
    });
  } else {
    initAllSupportHomes(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initAllSupportHomes(event.target);
  });
})();
